import ToggleSwitch from '../../../../ui/buttons/ToggleSwitch';
import { useTranslation } from 'react-i18next';
import {
  initialInputData,
  transformInputData,
} from '../../../../lib/constants/trackingClassesData';
import post_integration_api_call from '../../../../lib/api/integration/post_integration_api_call';
import { useState } from 'react';
import getInitialValuesViaTrackingConfigurations from '../../../../lib/helper-functions/getInitialValuesViaTrackingConfigurations';

interface Props {
  setIsAutofillEnabled: (value: boolean) => void;
  isAutofillEnabled: boolean;
  isTrackerON: boolean;
  optimizeValue: number;
  data: any;
  setAPIData: (data: any) => void;
  setScriptKey: (key: string) => void;
}

const Autofill = ({
  setIsAutofillEnabled,
  isAutofillEnabled,
  isTrackerON,
  optimizeValue,
  data,
  setAPIData,
  setScriptKey,
}: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const trackingInputValues = data
    ? getInitialValuesViaTrackingConfigurations(
        data?.configuration,
        transformInputData(initialInputData)
      )
    : transformInputData(initialInputData);

  async function onConfirmHandler(isEnabled: boolean) {
    setIsLoading(true);
    const isEverythingNull = !Object.values(trackingInputValues).some(
      (value) => value !== ''
    );

    const autofillEnabledObj: { is_autofill_enabled: 'true' | 'false' } = {
      is_autofill_enabled: isEnabled ? 'true' : 'false',
    };

    const trackerSwitchObj: { is_tracker_active: 'true' | 'false' } = {
      is_tracker_active: isTrackerON ? 'true' : 'false',
    };

    const optimizationAdjustmentRatioObj: {
      optimization_adjustment_ratio: number;
    } = {
      optimization_adjustment_ratio: optimizeValue ?? 0,
    };

    try {
      const sendingData: any = {
        name: 'checkout-tracking-class-names',
        type: 'tracker',
        configuration: isEverythingNull
          ? { key: 'value' }
          : trackingInputValues,
      };

      if (data) {
        sendingData['_method'] = 'put';
      }

      const customMsg = isEnabled
        ? t('Autofill-Enabled-msg')
        : t('Autofill-Disabled-msg');

      const res = await post_integration_api_call(
        sendingData,
        data ? data?.slug : undefined,
        autofillEnabledObj,
        trackerSwitchObj,
        optimizationAdjustmentRatioObj,
        customMsg
      );
      if (res?.api_key) {
        setAPIData(res);
        setScriptKey(res?.api_key);
      }
      setIsLoading(false);
    } catch (exception) {
      console.log('Error during authentication request');
      setIsLoading(false);
      // submitLogToBugsnag('error', `${exception}`);
    }
  }

  return (
    <div className='normalForm'>
      <div className='normalForm__top'>
        <h2>{t('AutofillSectionTitle')}</h2>
        <hr />
        <div className='commonPage__container1-alignLeft'>
          <ToggleSwitch
            isOn={isAutofillEnabled}
            title={t('ParticipateInAdUpNetwork')}
            onClick={() => {
              setIsAutofillEnabled(!isAutofillEnabled);
              onConfirmHandler(!isAutofillEnabled);
            }}
            classes='margin-top-2rem'
            id='Tracking-Autofill'
            disabled={isLoading}
          />
        </div>
        <span>{t('AutofillEnableDescription')}</span>
      </div>
    </div>
  );
};

export default Autofill;
